import $ from 'jquery'

export class FaqSection {

  constructor($container)
  {
			// this.$clone_form = $container.find('.full-form-clone-form')
  }

}
